const NavModel = [
    {
        name: 'Home',
        link: '/#home'
    },
    {
        name:'About',
        link: '/#about'
    },
    {
        name:'Skills',
        link:'/#skill'
    },
    {
        name:'Projects',
        link:'/#projects'
    },
    // {
    //     name:"Project List",
    //     link:"/projects"
    // },
    {
        name:'Contact',
        link:'/#contact'
    },
]

export default NavModel